import { LoadingSpinner } from '@web_opxp/components';
import { lazy, Suspense } from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import ENV from './base/env';
import { history } from './base/historyService';
import Checkout from './CheckoutWrapper';
import { NavigationBlockProvider } from './medBanner';

const Subscribe = lazy(() => import('./SubscribeWrapper'));
// this lazy import makes build to fail because of chaos in css imports
// we need to find out how to fix it before we can actually import it in a lazy mode
//const Checkout = lazy(() => import('./CheckoutWrapper'));
const Manage = lazy(() => import('./ManageWrapper'));
const Orders = lazy(() => import('./OrdersWrapper'));
const DirectSubscribe = lazy(() => import('./directSubscribe'));

export default function Root() {
  return (
    <NavigationBlockProvider>
      <Router history={history}>
        <Suspense fallback={<LoadingSpinner assetsUrl={ENV.AssetsBaseUrl} />}>
          <Switch>
            <Route path="/checkout">
              <Checkout />
            </Route>
            <Route path="/manage">
              <Manage />
            </Route>
            <Route path="/orders">
              <Orders />
            </Route>
            <Route path="/direct/:productId">
              <DirectSubscribe />
            </Route>
            <Route path="/cb">
              <Subscribe />
            </Route>
            <Route>
              <Subscribe />
            </Route>
          </Switch>
        </Suspense>
      </Router>
    </NavigationBlockProvider>
  );
}
